import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  useTheme,
} from "@mui/material";
import StyledButton from "../../ui/buttons/StyledButton";
import ClickableImage from "../../layout/Interactive/Images/ClickableImage";

function RepresentativeGarmentModal({
  showModal,
  title,
  body,
  seedGarment,
  selectedGarment,
  onDismissTitle = "Return",
  onDismiss,
  onConfirmTitle = "Confirm",
  onConfirm = null,
  onDismissColour="primary",
  onConfirmColour="primary",
  sxImg={}
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [componentRendered, setComponentRendered] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (showModal && componentRendered) {
      // Show the dialog when waitToShowModal is complete
      setDialogOpen(true);
    } else {
      console.log("setComponentRendered");
      setComponentRendered(true);
    }
  }, [showModal]);

  const handlePreventClose = (event) => {
    event.preventDefault();
  };

  //if onConfirm is not supplied (is null) then show first set of dialogActions, otherwise show the second set (both buttons)
  const dialogActions = !onConfirm ? (
    <>
      <StyledButton
        onClick={() => {
          onDismiss();
          setDialogOpen(false);
        }}
        color={onDismissColour}
        variant="outlined"
        autoFocus
      >
        {onDismissTitle}
      </StyledButton>
    </>
  ) : (
    <Box
      sx={{ justifyContent: "space-between", display: "flex", width: "100%", p: 0.5, mt: -2 }}
    >
      <Box sx={{flexDirection: "column", p: 1}}>
        <StyledButton
          onClick={() => {
            onDismiss();
            setDialogOpen(false);
          }}
          color={onDismissColour}
          variant="outlined"
          autoFocus
          sx={{flexDirection: "column", fontSize: "1.25rem", color: theme.palette.primary[800]}}
        >
          <ClickableImage
            image={`https://scraped-garment-images.s3.eu-west-2.amazonaws.com/${
                seedGarment.uuid_public_id
              }-${1}.jpg`}
            alt={`seed-garment-image`}
            style={{ objectFit: "cover", margin: "auto", borderRadius: 2}}
            sxImg={{ borderRadius: "2px !important",
              marginTop: 2,
              marginBottom: 2, 
              height: "12rem",
              ...sxImg }}
          />
          
          {onDismissTitle}
        </StyledButton>
      </Box>

      <Box sx={{flexDirection: "column", p: 1}}>
        <StyledButton
          onClick={() => {
            onConfirm();
            setDialogOpen(false);
          }}
          color={onConfirmColour}
          variant="outlined"
          autoFocus
          sx={{flexDirection: "column", fontSize: "1.25rem", color: theme.palette.primary[800]}}
        >
          <ClickableImage
            image={`https://scraped-garment-images.s3.eu-west-2.amazonaws.com/${
                selectedGarment.uuid_public_id
              }-${1}.jpg`}
            alt={`seed-garment-image`}
            style={{ objectFit: "cover", margin: "auto", borderRadius: 2}}
            sxImg={{ borderRadius: "2px !important",
              marginTop: 2,
              marginBottom: 2, 
              height: "12rem",
              ...sxImg }}
          />

          {onConfirmTitle}
        </StyledButton>
      </Box>
    </Box>
  );

  return (
    <>
      <Dialog
        open={dialogOpen}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{fontSize: "1.5rem"}}>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{fontSize: "1.25rem"}}>
            {body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{dialogActions}</DialogActions>
      </Dialog>
    </>
  );
}

export default RepresentativeGarmentModal;
